import { memo } from 'react';

interface ADNProps {
  color?: string;
  size?: number;
}

const ADN = ({ color = '#666666', size = 14 }: ADNProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_27954_42792)">
        <mask
          id="mask0_27954_42792"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24">
          <path d="M24 0H0V24H24V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_27954_42792)">
          <path
            d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
            fill={color}
          />
          <path
            d="M11.641 12.3727L12.4452 14.8496H10.7841L11.5899 12.3727H11.641ZM12.7959 15.9299L13.2805 17.4224H14.7635L12.5071 10.877H10.7237L8.46411 17.4224H9.94707L10.4326 15.9299H12.7959Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_27954_42792">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default memo(ADN);
